// Sites round 2 (D15/D17) — a small status pill like the Agents client cards, replacing the
// oversized "HTML · Published" badge. Plain words only: Published, Draft, Changes not live.
export type PageStatus = "published" | "draft" | "changed";

export const statusOf = (page: any, dirty = false): PageStatus => {
  const live = Boolean(page?.pageSettings?.html?.publishedSlug);
  if (!live) return "draft";
  const moved = page?.pageSettings?.html?.publishedSlug !== page?.slug;
  return dirty || moved ? "changed" : "published";
};

const STYLE: Record<PageStatus, { label: string; cls: string; dot: string }> = {
  published: { label: "Published", cls: "bg-emerald-50 text-emerald-700 ring-emerald-200/60 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-400/20", dot: "bg-emerald-500" },
  draft: { label: "Draft", cls: "bg-gray-100 text-gray-600 ring-gray-200 dark:bg-white/5 dark:text-white/60 dark:ring-white/10", dot: "bg-gray-400" },
  changed: { label: "Changes not live", cls: "bg-amber-50 text-amber-700 ring-amber-200/60 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-400/20", dot: "bg-amber-500" },
};

export const StatusPill = ({ status }: { status: PageStatus }) => {
  const s = STYLE[status];
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ring-1 ${s.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};
